import { render, staticRenderFns } from "./itemProp.vue?vue&type=template&id=462fa900&scoped=true&"
import script from "./itemProp.vue?vue&type=script&lang=js&"
export * from "./itemProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462fa900",
  null
  
)

export default component.exports